import { net_filemanage } from "@/api/http";
export const API_STFMFM02C16_DisplayFileUpload = (...params) =>
net_filemanage.post("/api/STFMFM02C16/DisplayFileUpload", ...params)
export const API_STFMFM02C16_FileUpload = (...params) =>
net_filemanage.post("/api/STFMFM02C16/FileUpload", ...params)
export const API_STFMFM02C16_initClear = (...params) =>
net_filemanage.post("/api/STFMFM02C16/InitClear", ...params)